import styled from 'styled-components';

/**
 * The inline rule between two groups of controls in a toolbar (Creator Studio
 * top bar, timeline controls). Hairline, 20px tall, one per toolbar at most —
 * see "Structural Lines" in docs/design-system.md.
 */
export const VerticalSeparator = styled.div`
  flex-shrink: 0;
  width: 1px;
  height: 20px;
  background-color: var(--border-subtle);
`;
